import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
// import Exclamation from 'assets/images/exclamation.svg'
// import quesMark from 'assets/images/ques-mark.svg'

// const StyledImage = styled.img`
//   margin-left: 4px;
//   width: fit-content;
//   height: fit-content;
//   max-width: 24px;
//   max-height: 24px;
// `

export type TooltipItemType = {
  id?: string
  icon?: string
  content: any
  className?: string
}

const ToolTipItem = ({ id, className, icon, content }: TooltipItemType) => (
  <>
    <StyledTooltipLabel
      data-tip
      data-for={`Tooltip-${id}`}
      // width={24}
      // src={icon ? quesMark : Exclamation}
      className={className}
      // alt="hint"
    >
      Info
    </StyledTooltipLabel>
    <StyledTooltip
      className="main_tooltip"
      id={`Tooltip-${id}`}
      place={'top'}
      effect="float"
      backgroundColor="#00283C"
    >
      {content}
    </StyledTooltip>
  </>
)

ToolTipItem.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  content: PropTypes.any,
  placement: PropTypes.string,
}

export default ToolTipItem

const StyledTooltipLabel = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 150%;
  text-decoration-line: underline;
  color: #19b3ff;
  margin-left: 15px;
  max-width: 400px;
  cursor: default;
`

const StyledTooltip = styled(ReactTooltip)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  max-width: 233px;
  padding: 7px 11px;
`
